import { getRect } from '@fluentui/react/lib/Utilities';
import { wrapForcedLayout } from 'owa-performance';

export class ListAnimationRowMeasurementError extends Error {
    constructor() {
        super('Unable to measure a mail list animation row.');
    }
}

export function measureListAnimationRow(row: Element, source: string): DOMRect {
    const rect = wrapForcedLayout(source, () => getRect(row as HTMLDivElement));
    if (!rect) {
        throw new ListAnimationRowMeasurementError();
    }
    return new DOMRect(rect.left, rect.top, rect.width, rect.height);
}
